import { getCampaignUtmCodeUrls } from "relay/campaigns";

export const getUtmLinks = async (id) => {
  try {
    let response = await getCampaignUtmCodeUrls(id);
    if (response.campaignUtmCodeUrls) {
      return response.campaignUtmCodeUrls
    } else {
      return null
    }
  } catch{
    return null
  }
}
